<template>
	
	<div v-if="merchandising.content && merchandising.content[ type ]" class="g-searchspring__merchandising">
		<div v-for="(banner, index) in merchandising.content[ type ]" :key="index" :class="{['is-' + type]: true, 'u-mt-s u-mt--m': type === 'banner', 'g-product-list-footer': type === 'footer'}" class="g-searchspring__banner u-mb-s u-mb--m">
			<div v-html="banner" :class="{'g-product-list-header__image': type ==='header', 'g-product-list-footer__content': type === 'footer'}"></div>
		</div>
	</div>

</template>

<style lang="scss" scoped>

	@import "variables";

	.g-searchspring__banner {

		&.is-left {
			padding: $unit-medium 0;

			@include media(">=large") {
				margin: {
					bottom: $unit;
					right: $unit-large;
				}
			}

			@include media(">=xxlarge") {
				margin-right: $unit-xlarge;
			}

			@include media(">=xxxlarge") {
				margin-right: 119px;
			}
		}
	} 

</style>

<script>

	export default {
		props: {
			merchandising: {
				default() {
					return {}
				}
			},
			type: {
				type: String
			}
		}
	}

</script>
